import {Pipe, PipeTransform} from '@angular/core';
import {getFlooredFixed} from '../utils/helper';
import { Constants } from '../utils/constants';
import FIXED_NUMBER = Constants.FIXED_NUMBER;

const nums = [
  '0.000000',
  '0.00000',
  '0.0000',
  '0.000',
  '0.00',
  '0.0',
  '+0.000000',
  '+0.00000',
  '+0.0000',
  '+0.000',
  '+0.00',
  '+0.0',
  '-0.000000',
  '-0.00000',
  '-0.0000',
  '-0.000',
  '-0.00',
  '-0.0',
];

@Pipe({ name: 'txNumber' })
export class TxNumberPipe implements PipeTransform {
  transform(value: any = 0, type: string, unrounded = false): string {
    value = value || 0;
    if (typeof value === 'string') {
      if (value === '-' || value.toUpperCase() === 'N/A') {
        return value;
      }
      value = parseFloat(value);
    }
    type = type ? type.toUpperCase() : '0';
    switch (type) {
      case 'BTC':
        return nums.indexOf(value.toFixed(5)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 5)
          : value.toFixed(5);
      case 'ETH':
        return nums.indexOf(value.toFixed(3)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 3)
          : value.toFixed(3);
      case 'XRP':
        return nums.indexOf(value.toFixed(1)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 1)
          : value.toFixed(1);
      case 'USD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'JPY':
        return nums.indexOf(value.toFixed(0)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 0)
          : value.toFixed(0);
      case 'USDT':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'BTCUSD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'ETHUSD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'XRPUSD':
        return nums.indexOf(value.toFixed(4)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 4)
          : value.toFixed(4);
      case 'BCHUSD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'LTDUSD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'USDJPY':
        return nums.indexOf(value.toFixed(3)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 3)
          : value.toFixed(3);
      case 'GBPJPY':
        return nums.indexOf(value.toFixed(3)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 3)
          : value.toFixed(3);
      case 'EURUSD':
        return nums.indexOf(value.toFixed(5)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 5)
          : value.toFixed(5);
      case 'AUDJPY':
        return nums.indexOf(value.toFixed(3)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 3)
          : value.toFixed(3);
      case 'EURAUD':
        return nums.indexOf(value.toFixed(5)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 5)
          : value.toFixed(5);
      case 'EURGBP':
        return nums.indexOf(value.toFixed(5)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 5)
          : value.toFixed(5);
      case 'EURJPY':
        return nums.indexOf(value.toFixed(3)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 3)
          : value.toFixed(3);
      case 'GBPAUD':
        return nums.indexOf(value.toFixed(5)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 5)
          : value.toFixed(5);
      case 'GBPUSD':
        return nums.indexOf(value.toFixed(5)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 5)
          : value.toFixed(5);
      case 'AUDUSD':
        return nums.indexOf(value.toFixed(5)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 5)
          : value.toFixed(5);
      case 'WTI_N0':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'XAUUSD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'XAGUSD':
        return nums.indexOf(value.toFixed(3)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 3)
          : value.toFixed(3);
      case 'WTI_Q0':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'XBRUSD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'XNGUSD':
        return nums.indexOf(value.toFixed(4)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 4)
          : value.toFixed(4);
      case 'XTIUSD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'XPTUSD':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'US30':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'AUS200':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'DE30':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'F40':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'JP225':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'STOXX50':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'UK100':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'US500':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'USTEC':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'CHINA50':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'ES35':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'HK50':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case 'IT40':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);

      case '0':
        return nums.indexOf(value.toFixed(0)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 0)
          : value.toFixed(0);
      case '1':
        return nums.indexOf(value.toFixed(1)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 1)
          : value.toFixed(1);
      case '2':
        return nums.indexOf(value.toFixed(2)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 2)
          : value.toFixed(2);
      case '3':
        return nums.indexOf(value.toFixed(3)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 3)
          : value.toFixed(3);
      case '4':
        return nums.indexOf(value.toFixed(4)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 4)
          : value.toFixed(4);
      case '5':
        return nums.indexOf(value.toFixed(5)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 5)
          : value.toFixed(5);
      case '6':
        return nums.indexOf(value.toFixed(6)) >= 0
          ? '0'
          : unrounded
          ? getFlooredFixed(value, 6)
          : value.toFixed(6);
      default:
        return value.toString();
    }
  }
}

@Pipe({ name: 'noneScientificNotation' })
export class NoneScientificNotationPipe implements PipeTransform {
  transform(value: any = 0): string {
    value = value || 0;
    return value.toLocaleString('fullwide', { maximumFractionDigits: 20 });
  }
}

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    }
    return value[0].toUpperCase() + value.substr(1).toLowerCase();
  }
}

@Pipe({ name: 'stringtosplit' })
export class StringToSplit implements PipeTransform {
  transform(value: string): string {
    let str = value;
    if (value) {
      let strArr = value.split(/(?=[A-Z])/);
      if(strArr.length > 0){
        str = '';
        strArr.forEach((val, index) => {
          str += val +' ';
        })
        str.trim();
      }
    }
    return str;
  }
}

@Pipe({name: 'DecimalPipe'})
export class NumNotRoundPipe implements PipeTransform {
  transform(value = 0, decimalNumber: string = FIXED_NUMBER.usd): string {
    const currencyValue = value > 1 ? new Intl.NumberFormat('en-EN', {
      maximumFractionDigits: 20
    }).format(value) : value;
    const conditionSlice = Number(decimalNumber.split('-')[1]);
    let [int, tail] = String(currencyValue).split('.');
    if (!conditionSlice) {
      return String(int);
    }
    if(!tail) tail = ''
    if(tail.length>conditionSlice){
      tail = tail.slice(0, conditionSlice)
    }
    tail = tail.padEnd(conditionSlice, "0")
    return `${int}.${tail}`;
  }
}

@Pipe({name: 'includes'})
export class IncludesPipe implements PipeTransform {
  transform(value: any[], member: any): boolean {
    return value?.includes?.(member);
  }
}
